import React, { useState } from 'react';
import { Tooltip } from './Tooltip';
import { Link } from 'react-scroll';
import { navConfig, feedConfig } from '../config/navConfig';
import MenuItem from './MenuItem';

const Header = ({ lang, setLang, homeRef }) => {
  const [isNavModalClose, setIsNavModalClose] = useState(true);
  return (
    <header id="header" className="sticky-top">
      {/* Navbar */}
      <nav className="primary-menu navbar navbar-expand-lg navbar-dark bg-dark border-bottom-0">
        <div className="container-fluid position-relative h-100 flex-lg-column ps-3 px-lg-3 pt-lg-3 pb-lg-2">
          {/* Logo */}
          <Link
            smooth
            duration={500}
            style={{ cursor: 'pointer' }}
            to="home"
            className="mb-lg-auto mt-lg-4"
            onClick={(e) => {
              e.preventDefault();
              setIsNavModalClose(true);
            }}>
            <span className="bg-dark-2 rounded-pill p-2 mb-lg-1 d-none d-lg-inline-block">
              <img
                className="img-fluid rounded-pill d-block"
                src="images/profile.jpg"
                title="We are Go-numerik"
                alt="profile"
              />
            </span>
            <h1 className="text-5 text-white text-center mb-0 d-lg-block">
              gonumerik
            </h1>
          </Link>
          {/* Logo End */}
          <div
            id="header-nav"
            className={
              isNavModalClose
                ? 'collapse navbar-collapse w-100 my-lg-auto '
                : 'show navbar-collapse w-100 my-lg-auto'
            }>
            <ul className="navbar-nav text-lg-center my-lg-auto py-lg-3">
              {navConfig.map((config) => (
                <MenuItem
                  key={config.titleKey}
                  titleKey={config.titleKey}
                  linkTo={config.linkTo}
                  linkRef={config.linkTo === 'home' ? homeRef : null}
                  title={config.defaultTitle}
                  defaultTitle={config.defaultTitle}
                  onClick={(e) => {
                    e.preventDefault();
                    setIsNavModalClose(true);
                  }}
                  source="classic-header"
                />
              ))}
            </ul>
          </div>
          <div className="lang-open">
            <span
              onClick={() => setLang('fr')}
              style={{ color: lang === 'fr' ? '#9acd32' : '#ddd' }}>
              FR
            </span>{' '}
            &nbsp;| &nbsp;
            <span
              onClick={() => setLang('en')}
              style={{ color: lang === 'en' ? '#9acd32' : '#ddd' }}>
              EN
            </span>
          </div>
          {/* <ul className="social-icons social-icons-muted social-icons-sm mt-lg-auto ms-auto ms-lg-0 d-flex">
            {
              feedConfig.map(config=>
                <li key={config.href}  className="social-icons-facebook">
                  <Tooltip text="Facebook" placement="top">
                    <a
                      href={config.href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className={config.className} />
                    </a>
                  </Tooltip>
                </li>)
            }
          </ul> */}
          <button
            onClick={(e) => {
              setIsNavModalClose(!isNavModalClose);
            }}
            className={
              isNavModalClose ? 'navbar-toggler' : 'navbar-toggler show'
            }
            id="navbar-toggler"
            type="button">
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>
      {/* Navbar End */}
    </header>
  );
};

export default Header;
